// extracted by mini-css-extract-plugin
export default {"label":"ImportReportEmail_label__Pqv04","input":"ImportReportEmail_input__2mYEN","placeHolderShimmer":"ImportReportEmail_placeHolderShimmer__59dfz"};